import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abae78b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "receivable-forecast receivable-list-page" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "office-loading" }, "加载中...", -1))
const _hoisted_4 = { class: "search-actions" }
const _hoisted_5 = { class: "expand-arrow" }
const _hoisted_6 = { class: "list-panel" }
const _hoisted_7 = { class: "list-toolbar" }
const _hoisted_8 = {
  key: 0,
  class: "action-btns"
}
const _hoisted_9 = { class: "pagination-bar" }
const _hoisted_10 = { class: "pagination-total" }

import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import type { TableProps } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import {
  buildForecastImportQueryData,
  pickClosestLDate,
  queryForecastLDateOptions,
  queryReceivableForecastPage,
  queryReceivableForecastToolbarAuth,
  RECEIVABLE_FORECAST_EXPORT_PATH,
  RECEIVABLE_FORECAST_IMPORT_PATH,
  RECEIVABLE_FORECAST_MODEL,
  type ReceivableForecastItem,
  type ReceivableForecastToolbarAuth,
} from './index';
import { querySalesOfficePage } from '../receivableCustomer';
import { useResizableColumns } from '../tableColumnResize';
import ExportDialog from '../receivableManage/ExportDialog.vue';
import EditExpectAmountDialog from './EditExpectAmountDialog.vue';
import ViewExpectAmountLogDialog from './ViewExpectAmountLogDialog.vue';
import ImportDialog from './ImportDialog.vue';
import SendMailDialog from './SendMailDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'receivableForecast',
  props: {
    onClose: null
  },
  setup(__props: any) {



const paginationLocale = zhCN.Pagination;

const financeAreaOptions = [
  { value: 'EAST', label: '东区' },
  { value: 'WEST', label: '西区' },
  { value: 'SOUTH', label: '南区' },
  { value: 'NORTH', label: '北区' },
];

const yesNoOptions = [
  { value: 'true', label: '是' },
  { value: 'false', label: '否' },
];

function toOptionalBoolean(value?: string) {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
}

const searchForm = reactive({
  lDate: undefined as string | undefined,
  financeArea: undefined as string | undefined,
  companyCode: undefined as string | undefined,
  financeOwner: '',
  customerCode: '',
  salesman: '',
  saleChannelName: '',
  isProfessional: undefined as string | undefined,
});

const lDateOptions = ref<{ value: string; label: string }[]>([]);
const lDateFetching = ref(false);

const searchExpanded = ref(false);
const searchColSpan = 8;

function toggleSearchExpand() {
  searchExpanded.value = !searchExpanded.value;
  nextTick(() => {
    requestAnimationFrame(() => updateTableScrollY());
  });
}

const loading = ref(false);
const dataSource = ref<ReceivableForecastItem[]>([]);
const tableAreaRef = ref<HTMLElement | null>(null);
const tableRenderKey = ref(0);

const TABLE_ROW_HEIGHT = 36;
const TABLE_HEADER_HEIGHT = 36;
const TABLE_SCROLLBAR_SIZE = 17;
const TABLE_BODY_FALLBACK = TABLE_ROW_HEIGHT * 8 + TABLE_SCROLLBAR_SIZE;
/** 操作列固定宽度：过宽时 fixed-right 表头占位会被撑开，与按钮错位 */
const ACTION_COL_WIDTH = 118;
const tableScrollY = ref<number | undefined>(undefined);
const tableAreaMaxHeight = ref<number | undefined>(undefined);
const tableBodyYScroll = ref(false);

const { columns, scrollX, handleResizeColumn } = useResizableColumns(
  [
    { title: '日期', dataIndex: 'lDate', key: 'lDate', width: 110, ellipsis: true },
    { title: '是否专业客户', dataIndex: 'isProfessional', key: 'isProfessional', width: 110, ellipsis: true },
    { title: '财务大区', dataIndex: 'financeArea', key: 'financeArea', width: 90, ellipsis: true },
    { title: '分公司', dataIndex: 'companyName', key: 'companyName', width: 100, ellipsis: true },
    { title: '销售渠道', dataIndex: 'channel', key: 'channel', width: 100, ellipsis: true },
    { title: '同一控制人', dataIndex: 'controller', key: 'controller', width: 110, ellipsis: true },
    { title: '分支财务', dataIndex: 'financeOwner', key: 'financeOwner', width: 100, ellipsis: true },
    { title: '业务员', dataIndex: 'salesman', key: 'salesman', width: 100, ellipsis: true },
    { title: '客户编码', dataIndex: 'customerCode', key: 'customerCode', width: 100, ellipsis: true },
    { title: '客户名称', dataIndex: 'customerName', key: 'customerName', width: 180, ellipsis: true },
    { title: '应收账款合计', dataIndex: 'receivableBalance', key: 'receivableBalance', width: 120, ellipsis: true },
    { title: '信用期内', dataIndex: 'creditWithin', key: 'creditWithin', width: 100, ellipsis: true },
    { title: '逾期金额', dataIndex: 'overdueAmt', key: 'overdueAmt', width: 100, ellipsis: true },
    { title: '月末到期金额', dataIndex: 'monthEndDueAmt', key: 'monthEndDueAmt', width: 120, ellipsis: true },
    { title: '预计逾期金额', dataIndex: 'expectOverdueAmount', key: 'expectOverdueAmount', width: 120, ellipsis: true },
    { title: '预计回款金额', dataIndex: 'expectRepayAmount', key: 'expectRepayAmount', width: 120, ellipsis: true },
    { title: '逾期原因及说明', dataIndex: 'overdueReason', key: 'overdueReason', width: 200, ellipsis: true },
    { title: '实际回款金额', dataIndex: 'actualReceiptAmt', key: 'actualReceiptAmt', width: 120, ellipsis: true },
    { title: '实际月末逾期金额', dataIndex: 'actualMonthEndOverdueAmt', key: 'actualMonthEndOverdueAmt', width: 140, ellipsis: true },
    { title: '回款达成率', dataIndex: 'repaymentRate', key: 'repaymentRate', width: 100, ellipsis: true },
    { title: '数据同步时间', dataIndex: 'dwsUpdateTime', key: 'dwsUpdateTime', width: 160, ellipsis: true },
    {
      title: '操作',
      key: 'action',
      width: ACTION_COL_WIDTH,
      fixed: 'right',
      align: 'left',
      className: 'col-action',
      resizable: false,
    },
  ],
  { hasSelection: true },
);

const selectedRowKeys = ref<string[]>([]);
const selectedIds = ref<string[]>([]);

const rowSelection = computed<TableProps['rowSelection']>(() => ({
  selectedRowKeys: selectedRowKeys.value,
  fixed: true,
  onChange: (keys: (string | number)[], rows: ReceivableForecastItem[]) => {
    selectedRowKeys.value = keys.map(String).filter(Boolean);
    selectedIds.value = [
      ...new Set(
        (rows ?? [])
          .map((row) => String(row?.id ?? '').trim())
          .filter(Boolean),
      ),
    ];
  },
}));

const editDialogVisible = ref(false);
const logDialogVisible = ref(false);
const importVisible = ref(false);
const exportVisible = ref(false);
const sendMailVisible = ref(false);
const currentRecord = ref<ReceivableForecastItem | null>(null);

const toolbarAuth = reactive<ReceivableForecastToolbarAuth>({
  canExport: false,
  canImport: false,
  canSendMail: false,
});

const importQueryData = computed(() =>
  buildForecastImportQueryData({
    lDate: searchForm.lDate,
    salesOfficeRegionCode: searchForm.financeArea,
    saleOfficeCode: searchForm.companyCode,
    sapCustomerCode: searchForm.customerCode,
    financeCode: searchForm.financeOwner,
    salesmanUserCode: searchForm.salesman,
    saleChannelName: searchForm.saleChannelName,
    isProfessional: toOptionalBoolean(searchForm.isProfessional),
  }),
);

/** 导出带当前列表筛选（与 queryPage queryData 一致） */
const exportQueryData = computed(() => importQueryData.value);

function handleEdit(record: ReceivableForecastItem) {
  currentRecord.value = record;
  editDialogVisible.value = true;
}

function handleViewLog(record: ReceivableForecastItem) {
  currentRecord.value = record;
  logDialogVisible.value = true;
}

function handleExport() {
  exportVisible.value = true;
}

function handleImport() {
  importVisible.value = true;
}

function handleSendMail() {
  sendMailVisible.value = true;
}

async function loadToolbarAuth() {
  const auth = await queryReceivableForecastToolbarAuth();
  toolbarAuth.canExport = auth.canExport;
  toolbarAuth.canImport = auth.canImport;
  toolbarAuth.canSendMail = auth.canSendMail;
}

const tableScroll = computed(() => {
  if (tableScrollY.value == null) {
    return { x: scrollX.value };
  }
  return { x: scrollX.value, y: tableScrollY.value };
});

const tableAreaStyle = computed(() => {
  const style: Record<string, string> = {};
  if (tableAreaMaxHeight.value != null) {
    style.maxHeight = `${tableAreaMaxHeight.value}px`;
  }
  if (tableScrollY.value != null) {
    style['--receivable-table-body-h'] = `${tableScrollY.value}px`;
  }
  style['--receivable-action-col-w'] = `${ACTION_COL_WIDTH}px`;
  style['--rc-row-height'] = `${TABLE_ROW_HEIGHT}px`;
  style['--rc-header-height'] = `${TABLE_HEADER_HEIGHT}px`;
  return style;
});

const pageSizeOptions = ['10', '15', '30', '50', '100', '200'];

const pagination = reactive({
  current: 1,
  pageSize: 15,
  total: 0,
});

function getRowKey(record: ReceivableForecastItem, index?: number) {
  const id = String(record?.id ?? '').trim();
  return id || `row-${pagination.current}-${index ?? 0}`;
}

function updateTableScrollY() {
  const area = tableAreaRef.value;
  if (!area) {
    tableScrollY.value = undefined;
    tableAreaMaxHeight.value = undefined;
    return;
  }
  const listPanel = area.parentElement as HTMLElement | null;
  const toolbar = listPanel?.querySelector('.list-toolbar') as HTMLElement | null;
  const paginationEl = listPanel?.querySelector('.pagination-bar') as HTMLElement | null;
  const headerEl = area.querySelector('.ant-table-header') as HTMLElement | null;
  const headerH = headerEl?.offsetHeight || TABLE_HEADER_HEIGHT;

  const panelH = listPanel?.clientHeight || area.clientHeight;
  const toolbarH = toolbar?.offsetHeight || 0;
  const paginationH = paginationEl?.offsetHeight || 0;
  const maxAreaH = Math.max(0, panelH - toolbarH - paginationH);
  const available = Math.floor(maxAreaH - headerH);
  const needed = Math.max(1, pagination.pageSize) * TABLE_ROW_HEIGHT + TABLE_SCROLLBAR_SIZE;

  if (available <= 0) {
    tableScrollY.value = TABLE_BODY_FALLBACK;
    tableAreaMaxHeight.value = undefined;
    tableBodyYScroll.value = true;
    return;
  }

  tableScrollY.value = available;
  tableAreaMaxHeight.value = maxAreaH || undefined;
  tableBodyYScroll.value = available < needed;
}

const OFFICE_PAGE_SIZE = 15;
const officeOptions = ref<{ value: string; label: string }[]>([]);
const officeFetching = ref(false);
const officeKeyword = ref('');
const officePage = ref(1);
const officeTotalPages = ref(1);
const officeHasMore = computed(() => officePage.value < officeTotalPages.value);
let officeSearchTimer: ReturnType<typeof setTimeout> | null = null;
let officeLoadingMore = false;

async function fetchOfficeOptions(reset: boolean) {
  if (officeFetching.value && !reset) return;
  if (!reset && (officeLoadingMore || !officeHasMore.value)) return;

  const nextPage = reset ? 1 : officePage.value + 1;
  officeFetching.value = true;
  if (!reset) officeLoadingMore = true;

  try {
    const pageData = await querySalesOfficePage({
      currentPage: nextPage,
      size: OFFICE_PAGE_SIZE,
      keyword: officeKeyword.value,
    });

    const mapped = (pageData.content ?? []).map((item) => ({
      value: item.code,
      label: item.name,
    }));

    officeOptions.value = reset
      ? mapped
      : mergeOfficeOptions(officeOptions.value, mapped);
    officePage.value = nextPage;
    officeTotalPages.value = Math.max(1, pageData.totalPages || 1);
  } catch (error) {
    if (reset) officeOptions.value = [];
    message.error(error instanceof Error ? error.message : '获取分公司失败');
  } finally {
    officeFetching.value = false;
    officeLoadingMore = false;
  }
}

function mergeOfficeOptions(
  prev: { value: string; label: string }[],
  next: { value: string; label: string }[],
) {
  const map = new Map(prev.map((item) => [item.value, item]));
  next.forEach((item) => map.set(item.value, item));
  return [...map.values()];
}

function onOfficeSearch(keyword: string) {
  officeKeyword.value = keyword;
  if (officeSearchTimer) clearTimeout(officeSearchTimer);
  officeSearchTimer = setTimeout(() => {
    fetchOfficeOptions(true);
  }, 300);
}

function onOfficePopupScroll(e: Event) {
  const target = e.target as HTMLElement;
  if (!target) return;
  const nearBottom = target.scrollTop + target.offsetHeight >= target.scrollHeight - 24;
  if (nearBottom) {
    fetchOfficeOptions(false);
  }
}

function onOfficeDropdownVisible(open: boolean) {
  if (open && officeOptions.value.length === 0) {
    officeKeyword.value = '';
    fetchOfficeOptions(true);
  }
}

async function loadLDateOptions() {
  lDateFetching.value = true;
  try {
    const dates = await queryForecastLDateOptions();
    lDateOptions.value = dates.map((d) => ({ value: d, label: d }));
    if (!searchForm.lDate) {
      searchForm.lDate = pickClosestLDate(dates);
    }
  } catch (error) {
    lDateOptions.value = [];
    message.error(error instanceof Error ? error.message : '获取日期选项失败');
  } finally {
    lDateFetching.value = false;
  }
}

async function fetchList() {
  loading.value = true;
  dataSource.value = [];
  selectedRowKeys.value = [];
  selectedIds.value = [];
  try {
    const pageData = await queryReceivableForecastPage({
      currentPage: pagination.current,
      size: pagination.pageSize,
      lDate: searchForm.lDate,
      salesOfficeRegionCode: searchForm.financeArea,
      saleOfficeCode: searchForm.companyCode,
      sapCustomerCode: searchForm.customerCode,
      financeCode: searchForm.financeOwner,
      salesmanUserCode: searchForm.salesman,
      saleChannelName: searchForm.saleChannelName,
      isProfessional: toOptionalBoolean(searchForm.isProfessional),
    });
    dataSource.value = pageData.content;
    pagination.total = pageData.totalElements;
    tableRenderKey.value += 1;
    nextTick(() => {
      requestAnimationFrame(() => updateTableScrollY());
    });
  } catch (error) {
    dataSource.value = [];
    pagination.total = 0;
    tableRenderKey.value += 1;
    message.error(error instanceof Error ? error.message : '获取应收逾期预测列表失败');
  } finally {
    loading.value = false;
  }
}

function handleSearch() {
  if (!searchForm.lDate) {
    message.error('日期不能为空');
    return;
  }
  pagination.current = 1;
  selectedRowKeys.value = [];
  selectedIds.value = [];
  fetchList();
}

async function handleReset() {
  searchForm.financeArea = undefined;
  searchForm.companyCode = undefined;
  searchForm.financeOwner = '';
  searchForm.customerCode = '';
  searchForm.salesman = '';
  searchForm.saleChannelName = '';
  searchForm.isProfessional = undefined;
  searchForm.lDate = pickClosestLDate(lDateOptions.value.map((o) => o.value));
  pagination.current = 1;
  selectedRowKeys.value = [];
  selectedIds.value = [];
  if (!lDateOptions.value.length) {
    await loadLDateOptions();
  }
  fetchList();
}

function onPaginationChange(page: number, pageSize: number) {
  const sizeChanged = pageSize !== pagination.pageSize;
  pagination.current = sizeChanged ? 1 : page;
  pagination.pageSize = pageSize;
  selectedRowKeys.value = [];
  selectedIds.value = [];
  fetchList();
}

let tableAreaRo: ResizeObserver | null = null;

onMounted(async () => {
  await Promise.all([loadLDateOptions(), loadToolbarAuth()]);
  await fetchList();
  window.addEventListener('resize', updateTableScrollY);
  requestAnimationFrame(() => {
    updateTableScrollY();
    if (tableAreaRef.value && typeof ResizeObserver !== 'undefined') {
      tableAreaRo = new ResizeObserver(() => updateTableScrollY());
      tableAreaRo.observe(tableAreaRef.value);
    }
    requestAnimationFrame(() => updateTableScrollY());
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', updateTableScrollY);
  tableAreaRo?.disconnect();
  tableAreaRo = null;
  if (officeSearchTimer) clearTimeout(officeSearchTimer);
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["search-bar", { collapsed: !searchExpanded.value }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["search-bar-body", { expanded: searchExpanded.value }])
        }, [
          _createVNode(_component_a_form, {
            layout: "horizontal",
            colon: false,
            model: searchForm,
            class: "search-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [12, 12] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "日期" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchForm.lDate,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.lDate) = $event)),
                            "allow-clear": false,
                            placeholder: "选择日期",
                            options: lDateOptions.value,
                            loading: lDateFetching.value
                          }, null, 8, ["value", "options", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "财务大区" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchForm.financeArea,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.financeArea) = $event)),
                            "allow-clear": "",
                            placeholder: "全部",
                            options: financeAreaOptions
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "客户" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: searchForm.customerCode,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.customerCode) = $event)),
                            "allow-clear": "",
                            placeholder: "输入客户编码或名称",
                            onPressEnter: handleSearch
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (searchExpanded.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "分公司" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.companyCode,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.companyCode) = $event)),
                                  "show-search": "",
                                  "allow-clear": "",
                                  placeholder: "输入编码或名称搜索",
                                  "filter-option": false,
                                  options: officeOptions.value,
                                  "not-found-content": officeFetching.value ? undefined : null,
                                  onSearch: onOfficeSearch,
                                  onPopupScroll: onOfficePopupScroll,
                                  onDropdownVisibleChange: onOfficeDropdownVisible
                                }, _createSlots({ _: 2 }, [
                                  (officeFetching.value)
                                    ? {
                                        name: "notFoundContent",
                                        fn: _withCtx(() => [
                                          _hoisted_3
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032, ["value", "options", "not-found-content"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "销售渠道" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.saleChannelName,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.saleChannelName) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入销售渠道名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "业务员" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.salesman,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchForm.salesman) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入工号或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "分支财务" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.financeOwner,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchForm.financeOwner) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入工号或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "是否专业客户" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.isProfessional,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchForm.isProfessional) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: yesNoOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: handleSearch
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { onClick: handleReset }, {
              default: _withCtx(() => [
                _createTextVNode("重置")
              ]),
              _: 1
            }),
            _createElementVNode("a", {
              class: "expand-toggle",
              onClick: toggleSearchExpand
            }, [
              _createTextVNode(_toDisplayString(searchExpanded.value ? '收起' : '展开') + " ", 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(searchExpanded.value ? '▲' : '▼'), 1)
            ])
          ])
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (toolbarAuth.canExport)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: handleExport
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 导出 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (toolbarAuth.canImport)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    onClick: handleImport
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 导入 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (toolbarAuth.canSendMail)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    type: "primary",
                    onClick: handleSendMail
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 发送邮件 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          ref_key: "tableAreaRef",
          ref: tableAreaRef,
          class: "table-area",
          style: _normalizeStyle(_unref(tableAreaStyle))
        }, [
          (_openBlock(), _createBlock(_component_a_table, {
            key: tableRenderKey.value,
            class: _normalizeClass(["receivable-table", { 'is-y-scroll': tableBodyYScroll.value }]),
            columns: _unref(columns),
            "data-source": dataSource.value,
            loading: loading.value,
            pagination: false,
            scroll: _unref(tableScroll),
            bordered: true,
            "row-key": getRowKey,
            "row-selection": _unref(rowSelection),
            size: "small",
            onResizeColumn: _unref(handleResizeColumn)
          }, {
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.key === 'action')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_a_button, {
                      type: "link",
                      size: "small",
                      onClick: ($event: any) => (handleEdit(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "link",
                      size: "small",
                      onClick: ($event: any) => (handleViewLog(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 查看日志 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(text ?? ''), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["class", "columns", "data-source", "loading", "scroll", "row-selection", "onResizeColumn"]))
        ], 4),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(pagination.total) + " 条", 1),
          _createVNode(_component_a_pagination, {
            current: pagination.current,
            "onUpdate:current": _cache[8] || (_cache[8] = ($event: any) => ((pagination.current) = $event)),
            pageSize: pagination.pageSize,
            "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((pagination.pageSize) = $event)),
            total: pagination.total,
            "show-size-changer": true,
            "show-quick-jumper": true,
            "page-size-options": pageSizeOptions,
            locale: _unref(paginationLocale),
            onChange: onPaginationChange
          }, null, 8, ["current", "pageSize", "total", "locale"])
        ])
      ])
    ]),
    _createVNode(EditExpectAmountDialog, {
      visible: editDialogVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((editDialogVisible).value = $event)),
      record: currentRecord.value,
      onSubmitted: fetchList
    }, null, 8, ["visible", "record"]),
    _createVNode(ViewExpectAmountLogDialog, {
      visible: logDialogVisible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((logDialogVisible).value = $event)),
      record: currentRecord.value
    }, null, 8, ["visible", "record"]),
    _createVNode(ImportDialog, {
      visible: importVisible.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((importVisible).value = $event)),
      "id-list": selectedIds.value,
      "query-data": _unref(importQueryData),
      path: _unref(RECEIVABLE_FORECAST_IMPORT_PATH),
      onSuccess: fetchList
    }, null, 8, ["visible", "id-list", "query-data", "path"]),
    _createVNode(ExportDialog, {
      visible: exportVisible.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((exportVisible).value = $event)),
      "query-data": _unref(exportQueryData),
      model: _unref(RECEIVABLE_FORECAST_MODEL),
      path: _unref(RECEIVABLE_FORECAST_EXPORT_PATH)
    }, null, 8, ["visible", "query-data", "model", "path"]),
    _createVNode(SendMailDialog, {
      visible: sendMailVisible.value,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((sendMailVisible).value = $event)),
      "default-l-date": searchForm.lDate
    }, null, 8, ["visible", "default-l-date"])
  ]))
}
}

})